import { useRef } from 'react';
// Use effect prior art comes from https://github.com/kentcdodds/use-deep-compare-effect/blob/master/src/index.ts
export var useEqMemoize = function (value, eq, options) {
    var ref = useRef();
    var signalRef = useRef(0);
    if (ref.current == null) {
        ref.current = value;
    }
    if (!eq.equals(value, ref.current)) {
        // https://stackoverflow.com/questions/35469836/detecting-production-vs-development-react-at-runtime
        if (options && options.debug && process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.info('Stable hook update triggered:', { 'prev': ref.current, 'value': value });
        }
        ref.current = value;
        signalRef.current += 1;
    }
    return [signalRef.current];
};
//# sourceMappingURL=useEqMemoize.js.map